import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { StageComponent } from './stage/stage.component';

@Component({
  selector: 'lib-principal',
  imports: [CommonModule, HeaderComponent, SidenavComponent, StageComponent],
  template: '<lib-sidenav/><lib-header/><lib-stage/>',
})
export class PrincipalComponent {}
